import { debounce } from 'lodash';


(function (cash) {
    "use strict";

    var search_cancel = [];
    let searching_text = cash('#search_searching').text();
    let searching_typing = cash('#search_typing').text();
    let failure = cash('#search_fail').text();

    var getSearch = _.debounce(function(input){
        let query = input.val();

        if(query == ''){
            return false;
        }

        input.data('search-dirty',0);

        console.log('Searching :'+query);

        let content = input.closest('.search_holder')
        .find('.search-result')
        .find('.search-result__content');

        cash(".top-bar, .top-bar-boxed")
        .find(".search-result__content__status").text(searching_text+'...');

        input.data('searching',1);
        window.axios.post('/search',{
            'query':query
        },{
            cancelToken: search_cancel[input.data('search-index')].token
        })
        .then( function(response){
            console.log('server_success');
            cash(".top-bar, .top-bar-boxed")
            .find(".search-result__content__status").text('Success');
            input.data('searching',0);
            content.html( response.data );
        }).catch(function (thrown) {
            if (axios.isCancel(thrown)) {
                console.log('is_canceled');
                cash(".top-bar, .top-bar-boxed")
                .find(".search-result__content__status").text('');
                input.data('searching',0);
            }else{
                console.log('server_error');
                cash(".top-bar, .top-bar-boxed")
                .find(".search-result__content__status").text(failure);
                input.data('searching',0);
            }

        });

    },500);

    function getInit( input ) {

        let content = input.closest('.search_holder')
        .find('.search-result')
        .find('.search-result__content');

        if(  cash('#search_init').html().trim() == '' ){
            window.axios.get('/search/init')
            .then( function(response){
                cash('#search_init').html( response.data );
                content.html( cash('#search_init').html() );
                input.data('searching',0);
            }).catch(function (error) {
                cash(".top-bar, .top-bar-boxed")
                .find(".search-result__content__status").text(failure);
                input.data('searching',0);
            });
        }else{
            content.html( cash('#search_init').html() );
            cash(".top-bar, .top-bar-boxed")
            .find(".search-result__content__status").text('');
            input.data('searching',0);
        }

    }

    cash( function() {
        cash(".top-bar, .top-bar-boxed")
        .find(".search")
        .find("input")
        .each(function (index) {

            cash(this).data('search-index',index);

            const CancelToken = window.axios.CancelToken;
            search_cancel[index] = CancelToken.source();

            getInit( cash(this) );

            cash(this).on("focus", function () {
                cash(".top-bar, .top-bar-boxed")
                    .find(".search-result")
                    .addClass("show");
            });

            cash(this).on("focusout", function () {
                cash(".top-bar, .top-bar-boxed")
                    .find(".search-result")
                    .removeClass("show");
            });

            cash(this).on("keyup", function () {

                cash(this).data('search-dirty',1);

                if( cash(this).data('searching') == '1' ){
                    search_cancel[cash(this).data('search-index')].cancel('Operation canceled by the user');
                    console.log('Search Cancelled');
                    cash(this).data('searching',0);
                    search_cancel[cash(this).data('search-index')] = CancelToken.source();
                    if( cash(this).val() == '' ){
                        return false;
                    }
                }

                cash(".top-bar, .top-bar-boxed")
                .find(".search-result__content__status").text(searching_typing+'...');

                if( cash(this).val() != '' ){
                    getSearch( cash(this) );
                }else{
                    getInit( cash(this) );
                }


            });
        });
    });

})(cash);

// let token = document.head.querySelector('meta[name="csrf-token"]');
//         fetch('/dashboard/location',{
//             method: "POST",
//             headers: {
//                 "X-CSRF-TOKEN": token.content,
//                 "X-Requested-With" : "XMLHttpRequest"
//             }
//         })
//         .then(response => response.json())
//         .then(json => {
//             cash(".top-bar, .top-bar-boxed")
//             .find(".search-result__content__title").text('Success');
//             input.data('searching',0);
//         }).catch((error)=>{
//             cash(".top-bar, .top-bar-boxed")
//             .find(".search-result__content__title").text('Failure');
//             input.data('searching',0);
//         });
